import { render, staticRenderFns } from "./sendMessage.vue?vue&type=template&id=418d70ae&scoped=true"
import script from "./sendMessage.vue?vue&type=script&lang=js"
export * from "./sendMessage.vue?vue&type=script&lang=js"
import style0 from "./sendMessage.vue?vue&type=style&index=0&id=418d70ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418d70ae",
  null
  
)

export default component.exports